import { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import DirectDepositImg from '../../assets/direct-deposit.svg';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../components/Checkbox/CheckboxGroup';
import GenericCard from '../../components/GenericCards/GenericCards';
import { RadioGroup } from '../../components/Radio';
import SelectableBankCard, {
  SelectableDefaultBankCard,
} from '../../components/SelectableBankCard';
import useMobile from '../../hooks/useMobileHook';
import useModal from '../../hooks/useModal';
import {
  accountNumberMask,
  addOrRemoveMonthsToGivenDate,
  formatDate,
} from '../../utils/utils';
import AddNewBankModal from '../widgets/retireOnlineModals/addNewBankModal/AddNewBankModal';

const directDepositData = {
  selectedBankOption: '1',
  selectedBank: {
    id: '1',
    name: 'Wells Fargo Bank',
    iban: '1234123412',
    routingNumber: '034802454',
    accountNumber: '43214321',
    type: 'Savings',
  },
  banksOptions: [
    {
      id: '1',
      name: 'Wells Fargo Bank',
      iban: '1234123412',
      routingNumber: '034802454',
      accountNumber: '43214321',
      type: 'Savings',
    },
    {
      id: '2',
      name: 'Bank of America',
      iban: '4321432143',
      routingNumber: '034804444',
      accountNumber: '12341234',
      type: 'Cheking',
    },
  ],
};

const DirectDeposit = () => {
  const [showModal, handleShowModal, handleCloseModal] = useModal();
  const [data, setData] = useState(directDepositData);
  const [show, setShow] = useState(false);
  const [value, setValue] = useState<string[]>([]);

  const handleBankOptionChange = (e: any) => {
    setData({
      ...data,
      selectedBankOption: e,
    });
  };

  const handleNewBank = (bank: any) => {
    setData({
      ...data,
      banksOptions: [...data.banksOptions, bank],
    });
  };

  const handleOnSave = () => {
    const selectedBank = data.banksOptions.filter(
      (bank) => data.selectedBankOption === bank.id
    );

    setData({
      ...data,
      selectedBank: selectedBank[0],
    });

    setShow(false);
  };

  const handleChange = (event: any, values: string[]) => {
    setValue(values);
  };

  const isMobile = useMobile();

  const date = new Date();
  const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

  return (
    <Container className="cnd-custom-container px-7 px-lg-0 pt-lg-12 mt-11 mt-lg-12">
      <section className="d-lg-flex flex-lg-row justify-content-between mb-13">
        <Col className="col-12 col-lg-6 d-flex flex-column justify-content-center">
          <h3 className="lh-xs text-sm-20-lg-48">Direct Deposit</h3>
          <span className="text-fs-6 lh-xs fw-light">
            Directly deposit the funds electronically into your bank account.
          </span>
        </Col>
        <Col className="pt-12 pt-lg-0 col-12 col-lg-6 d-lg-flex justify-content-lg-end">
          <img src={DirectDepositImg} alt="direct-deposit" />
        </Col>
      </section>
      <section>
        <GenericCard variant="white" style={{ zIndex: '1000' }}>
          <Col className="p-0 col-12">
            <Row className="m-0">
              <div className="p-0 text-sub1 text-dark-gray fw-light lh-xxs">
                <span>Plan</span>
              </div>
              <div className="p-0 text-dark-gray fw-light lh-xxs">
                <h5 className="mb-0">GRP Annuity</h5>
              </div>
            </Row>
            <Row className="m-0 mt-11 d-lg-flex flex-lg-row">
              <Row
                className={`m-0 ${
                  isMobile ? 'border-bottom' : ''
                } px-0 py-3 py-lg-0 col-lg-3 flex-lg-column`}
              >
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Account Type
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start mt-3">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {data.selectedBank.type}
                  </span>
                </Col>
              </Row>
              <Row
                className={`m-0 ${
                  isMobile ? 'border-bottom' : ''
                } px-0 py-3 py-lg-0 col-lg-3 flex-lg-column`}
              >
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Routing Number
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start mt-3">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {data.selectedBank.routingNumber}
                  </span>
                </Col>
              </Row>
              <Row
                className={`m-0 ${
                  isMobile ? 'border-bottom' : ''
                } px-0 py-3 py-lg-0 col-lg-3 flex-lg-column`}
              >
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Institution Name
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start mt-3">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {data.selectedBank.name}
                  </span>
                </Col>
              </Row>
              <Row className="m-0 px-0 py-3 py-lg-0 col-lg-2 flex-lg-column">
                <Col className="p-0">
                  <span className="fw-light text-sub1 lh-xxs text-ligther-grey">
                    Account Number
                  </span>
                </Col>
                <Col className="p-0 text-end text-lg-start mt-3">
                  <span className="fw-normal text-sub1 lh-xxs">
                    {accountNumberMask(data.selectedBank.iban, 2)}
                  </span>
                </Col>
              </Row>
              <Row className="m-0 p-0 pt-10 pt-lg-0 col-lg-1">
                <div className="p-0 d-flex justify-content-end align-items-lg-center">
                  <Button
                    variant="primary"
                    onClick={() => setShow(true)}
                    size="sm"
                    disabled={show}
                  >
                    Change
                  </Button>
                </div>
              </Row>
            </Row>
          </Col>
          {show && (
            <GenericCard className={'expandable-section mt-10 mt-lg-12'}>
              <Row className="m-0 pt-10 pt-lg-7">
                <div className="p-0 text-dark-gray fw-light lh-xxs">
                  <h5 className="mb-0 text-sm-20-lg-24">Change Payment</h5>
                </div>
                <div className="p-0 text-sub1 text-ligther-grey fw-light lh-xxs pt-1">
                  <span>Select from an existing account or add a new one</span>
                </div>
              </Row>
              <Container className="p-0 pt-10 d-flex flex-wrap">
                <RadioGroup
                  name={'banks'}
                  value={data.selectedBankOption}
                  onChange={handleBankOptionChange}
                >
                  {data.banksOptions.map((bank: any, i: number) => (
                    <SelectableBankCard
                      key={i}
                      item={bank}
                      className={'mb-7 mb-lg-0 me-lg-7'}
                      selected={data.selectedBankOption === bank.id}
                    />
                  ))}
                  <SelectableDefaultBankCard onClick={handleShowModal} />
                  <AddNewBankModal
                    showModal={showModal}
                    handleClose={handleCloseModal}
                    handleAddNewBank={handleNewBank}
                    banks={data.banksOptions}
                  />
                </RadioGroup>
              </Container>
              <Row className={'m-0 mt-7 p-0'}>
                <span className="p-0 fw-light text-sub1">{`Effective Date: ${formatDate(
                  addOrRemoveMonthsToGivenDate(new Date(firstDay), 1)
                )}`}</span>
              </Row>
              {data.selectedBankOption && (
                <Row className={'m-0 mt-11 p-0'}>
                  <Col className="d-flex flex-row col-lg-7 p-0">
                    <CheckboxGroup
                      name={'no-labels'}
                      value={value}
                      onChange={handleChange}
                    >
                      <Checkbox value={'1'} id={'2'} variant="sm" />
                    </CheckboxGroup>
                    <span className="ps-8 text-caption text-ligther-grey fw-light lh-xs">
                      I authorized that my benefit payments be deposited
                      directly into the account named above until I instruct
                      otherwise. If an incorrect amount is deposited into my
                      account, I authorize the appropriate adjustment to my
                      account.
                    </span>
                  </Col>
                </Row>
              )}
              <div className="d-flex flex-column flex-lg-row justify-content-center pt-10">
                <Button
                  variant="primary-outline"
                  className={'order-3 order-lg-2 mt-7 mt-lg-0'}
                  onClick={() => setShow(false)}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  className={'ms-lg-7 order-1 order-lg-3'}
                  onClick={handleOnSave}
                >
                  Save
                </Button>
              </div>
            </GenericCard>
          )}
        </GenericCard>
      </section>
    </Container>
  );
};

export default DirectDeposit;
